import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';
import { Inject, Injectable } from '@angular/core';
import { ApiClientService } from './api-client.service';
import { FilterModel } from '../models/filter.model';
import { Status } from '../enums/status.enum';
import { Observable } from 'rxjs';
import { SharedParams } from '../routes/shared-params.const';
@Injectable({
  providedIn: 'root',
})
export class BaseFucntionsService<T> {
  urlPrefix: string;

  constructor(
    @Inject(String) urlPrefix: string,
    protected apiClient: ApiClientService
  ) {
    this.urlPrefix = urlPrefix;
  }

  getPaging(data: FilterModel, additionalQuery?: string): Observable<any> {
    if (data?.sortField) {
      data.sortField =
        data.sortField.charAt(0).toUpperCase() + data.sortField.slice(1);
    }

    return this.apiClient.get(
      `${this.urlPrefix}?${this.joinQuery(this.getQueryString(data), additionalQuery)}`
    );
  }

  /**
   * Joins the paging query string (which ends with `&`) with an optional extra query without
   * producing `&&`, `&undefined` or a dangling `&` (E2E-ISSUE-108 item 3).
   */
  protected joinQuery(baseQuery: string, additionalQuery?: string | null): string {
    const extra = (additionalQuery ?? '').toString().replace(/^[?&]+/, '');
    const joined = `${baseQuery ?? ''}${extra}`;
    return joined.replace(/&{2,}/g, '&').replace(/&$/, '');
  }
  getList(): any {
    return this.apiClient.get(`${this.urlPrefix}`);
  }

  get(id: number): any {
    return this.apiClient.get(`${this.urlPrefix}/${id}`.replace('//', '/'));
  }

  getCurrent(): Observable<any> {
    return this.apiClient.get(`${ApplicationRoutes.Users.Current}`);
  }

  getDropDown(active: any = null): any {
    return this.apiClient.get(`${this.urlPrefix}/${SharedParams.Dropdown}?${active ? 'status=' + Status.Active : ''}`);
  }

  create(data: T): Observable<any> {
    return this.apiClient.create(`${this.urlPrefix}`, data);
  }

  update(data: T): any {
    return this.apiClient.update(`${this.urlPrefix}`, data);
  }

  delete(id: number): any {
    return this.apiClient.delete(id, `${this.urlPrefix}`);
  }

  getQueryString(data: FilterModel) {
    let queryString = '';
    Object.entries(data).forEach((item) => {
      if (item[1]) {
        queryString += `${item[0]}=${item[1]}&`;
      }
    });
    if (data.status == Status.Active) {
      queryString += `status=${Status.Active}&`;
    }
    return queryString;
  }

  getCountries() {
    return this.apiClient.get(`${ApplicationRoutes.Lookups.CountriesDropdown}`);
  }

  public getQualifications(): Observable<any> {
    return this.apiClient.get(`${ApplicationRoutes.Lookups.QualificationsDropdown}`)
  }
  getNationalities() {
    return this.apiClient.get(`${ApplicationRoutes.Lookups.NationalitiesDropdown}`);
  }

  public uploadUserProfile(userId: number, data: FormData): Observable<any> {
    return this.apiClient.customRequest('PUT', `${ApplicationRoutes.Users.UploadUserProfilePicture(userId)}`, data, true, 'text');
  }


  getCities(): any {
    return this.apiClient.get(`${ApplicationRoutes.Lookups.CitiesDropdown}`);
  }

  getRegions() {
    return this.apiClient.get(`${ApplicationRoutes.Lookups.RegionsDropdown}`);
  }
}
